import { render } from "./ProductBody.vue?vue&type=template&id=15014a3a"
import script from "./ProductBody.vue?vue&type=script&lang=js"
export * from "./ProductBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.33_vue@3.5.33_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__